import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import Store from "../index";
import { AttendeeDataArray, GetAttendeeDataOptions } from "@/types/interfaces";
import apiSvc from "../../services/api";

@Module({
    dynamic: true,
    store: Store,
    name: "getFeaturedAttendees",
    namespaced: true
})
export default class GetFeaturedAttendeesModule extends VuexModule {
    featuredAttendees: AttendeeDataArray = [];
    featuredAttendeeByType: AttendeeDataArray = [];

    @Mutation
    public setFeaturedAttendees(data: AttendeeDataArray) {
        this.featuredAttendees = data;
    }

    @Mutation
    public setFeaturedAttendeeByType(data: AttendeeDataArray) {
        this.featuredAttendeeByType = data;
    }

    @Action({ commit: "setFeaturedAttendees" })
    getFeaturedAttendees() {
        return new Promise((resolve, reject) => {
            apiSvc
                .getFeaturedAttendees()
                .then((response: any) => {
                    return resolve(response.data);
                })
                .catch((error: any) => {
                    return reject(error);
                });
        });
    }

    @Action({ commit: "setFeaturedAttendeeByType" })
    getFeaturedAttendeeByType(attendeeType: boolean) {
        return new Promise((resolve, reject) => {
            apiSvc
                .getFeaturedAttendeeByType(attendeeType)
                .then((response: any) => {
                    return resolve(response.data);
                })
                .catch((error: any) => {
                    return reject(error);
                });
        });
    }
}
